// File: /src/pages/CertificateView.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './ViewCertificate.css'; // You can style this as needed
import { getVCById } from '../../api/ssiAPI';
import { getTemplateById } from '../../api/certificateAPI';

function CertificateView() {
  const { id } = useParams(); // Extract certificate/VC ID from URL
  const [vcData, setVcData] = useState(null);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCertificateAndTemplate() {
      try {
        // Step 1: Fetch the VC by ID
        const vcResponse = await getVCById(id);
        const vc = vcResponse?.response[0].vc;
        console.log('VC response:', vc)
        setVcData(vc);

        // Step 2: Fetch associated template using vc.templateId
        const templateId = vc?.templateId;
        if (templateId) {
          const templateResponse = await getTemplateById(templateId);
          console.log('This is template:', templateResponse)
          setTemplate(templateResponse);
        }
      } catch (err) {
        console.error('❌ Failed to load certificate or template:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchCertificateAndTemplate();
  }, [id]);

  if (loading) return <div className="loading">Loading Certificate...</div>;
  if (!vcData || !template) return <div className="error">Certificate not found.</div>;

  const { credentialSubject } = vcData;
  const elements = template.elements || [];
  const backgroundImage = template.backgroundImageUrl;
  const logoImage = template.logoUrl;

  return (
    <div className="certificate-view">
      <div
        className="certificate-canvas"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          position: 'relative',
          width: '1000px',
          height: '700px',
          margin: '40px auto',
          border: '2px solid #ccc',
        }}
      >
        {/* Render each element with dynamic values */}
        {elements.map((el, index) => {
          if (el.type === 'text') {
            return (
              <div
                key={index}
                style={{
                  position: 'absolute',
                  top: el.y,
                  left: el.x,
                  width: el.width,
                  height: el.height,
                  fontSize: el.styles?.fontSize || 16,
                  color: el.styles?.color || '#000',
                  fontFamily: el.styles?.fontFamily || 'sans-serif',
                  fontWeight: el.styles?.fontWeight || 'normal',
                }}
              >
                {credentialSubject[el.id] || el.value || ''}
              </div>
            );
          }

          if (el.type === 'logo' && logoImage) {
            return (
              <img
                key={index}
                src={logoImage}
                alt="Logo"
                style={{
                  position: 'absolute',
                  top: el.y,
                  left: el.x,
                  width: el.width,
                  height: el.height,
                  objectFit: 'contain',
                }}
              />
            );
          }

          return null;
        })}
      </div>
    </div>
  );
}

export default CertificateView;
